import { getService } from 'data/function';
export class ToastProcessor {
    /**
     * Used as getter because angular injector function maybe not available
     * in the moment that this class is evaluated
     */
    static get ToastService() {
        return getService('BlipToastService');
    }
    static process({ message }) {
        const toastOptions = {
            msg: message.content.message,
            title: message.content.title,
            buttonText: message.content.buttontext,
            callback: message.content.callback,
            duration: message.content.duration,
        };
        ToastProcessor.ToastService.show(message.content.type, toastOptions);
        // Since this call is outside Angular lifecycle, we need to force a digest.
        // Using setTimeout to include it safely inside lifecycle
        setTimeout(() => { getService('$rootScope').$apply(); }, 10);
    }
}
